<template>
  <div id="SecretFotter">
    <footer class="footer" style="background-color: #0a0a0a;">
      <div class="content has-text-centered">
        <div class="columns">
          <div class="column">
            <p style="color: white;">
              5th Floor, 668 Sukhumvit24 Rd, Khlong Tan, Khlong Toei, Bangkok
              10110
              <br />Copyright © 2019 Secret Storey
            </p>

            <div class="columns is-mobile is-centered">
              <div class="column is-1-desktop is-4-tablet is-2-mobile">
                <a @click.prevent="openGoogleMap">
                  <b-icon type="is-light" size="is-medium" icon="google-maps" />
                </a>
              </div>
              <div class="column is-1-desktop is-4-tablet is-2-mobile">
                <a @click.prevent="openFacebook">
                  <b-icon
                    type="is-light"
                    size="is-medium"
                    icon="facebook-box"
                  />
                </a>
              </div>
              <div class="column is-1-desktop is-4-tablet is-2-mobile">
                <a @click.prevent="openInstagram">
                  <b-icon icon="instagram" size="is-medium" type="is-light" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "SecretFotter",
  methods: {
    isMobile: function() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    openGoogleMap: function() {
      window.open("https://goo.gl/maps/UuQspx6XoRGhZRfHA");
    },
    openFacebook: function() {
      window.open("https://www.facebook.com/SecretStorey/");
    },
    openInstagram: function() {
      window.open("http://instagram.com/secretstorey24");
    }
  }
};
</script>

<style></style>
